// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ATK4","toggleWrap":"styles_toggleWrap__2Vg-Q","content":"styles_content___hb-O","selectAreaCode":"styles_selectAreaCode__2hhfY"};